import React, { useState, useEffect } from "react";
import AppointmentCard from "../cards/AppointmentCard";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

//Dialog
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

//Date Picker
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

//Text Field
import TextField from "@mui/material/TextField";

import moment from "moment";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";

//Switch
import Switch from "@mui/material/Switch";

//Snackbar
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useSnackbar } from "notistack";

//Icons
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";

import isUserLoggedIn from "../helpers/redirect";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../../auth";

//JWT
import jwtDecode from "jwt-decode";

//Firebase
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { storage } from "../../../firebaseConfig";

//Loader spinner
import CircularProgress from "@mui/material/CircularProgress";
import Skeleton from "@mui/material/Skeleton";

import { getToken } from "../APIS/clientAPIS";
import { Pagination } from "@mui/material";
import { CalenderSvg } from "../helpers/Svg";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

dayjs.extend(localizedFormat);

const AppointmentDefaultView = ({ selectedTab, loading, setLoading, searchQuery = "" }) => {
  const [appointmentList, setAppointmentList] = useState([]);
  const [openRescheduleModal, setOpenRescheduleModal] = useState(false);
  const [slotsList, setSlotsList] = useState([]);
  const [checked, setChecked] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isCustomReschedule, setIsCustomReschedule] = useState(false);
  const [customTime, setCustomTime] = useState("");
  const [clientData, setClientData] = useState({
    slotID: 0,
    clientID: 0,
    clientName: "",
    clientImage: "",
    clientType: "",
    appointmentID: 0,
    appointmentDate: "",
    appointmentTime: "",
    clientStatus: "",
    clientCallingMode: "",
    callDuration: "",
    expertID: 0
  });

  // console.log("clientData ========>", clientData)

  const [openNotesModal, setOpenNotesModal] = useState(false);
  const [note, setNote] = useState("");
  const [openPrescriptionModal, setOpenPrescriptionModal] = useState(false);
  const [prescriptionName, setPrescriptionName] = useState("");
  const [prescriptionNote, setPrescriptionNote] = useState("");
  const [selectedFiles, setSelectedFiles] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [openCancelConfirmationModal, setOpenCancelConfirmationModal] =
    useState(false);

  const [bearerToken, setBearerToken] = useState(
    sessionStorage.getItem("token")
  );

  //Loaders States
  const [isFileLoading, setIsFileLoading] = useState(null);
  const [isCancelled, setIsCancelled] = useState(null);
  const [isPrescriptionAdded, setIsPrescriptionAdded] = useState(null);
  const [isRescheduled, setIsRescheduled] = useState(null);
  const [isNoteAdded, setIsNoteAdded] = useState(null);
  const [arrayLength, setArrayLength] = useState(16);
  const [height, setHeight] = useState(150);
  const [width, setWidth] = useState(300);
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser, userType, logout } = useAuth();

  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const headers = {
    "X-API-Key": "76d802e426a2cb28f3760c8c8f669983f67ed775",
    "Content-Type": "application/json",
  };

  const postSlotsData = async () => {
    let formattedDate = moment(clientData?.appointmentDate, ["DD/MM/YYYY", "DD MMM YYYY"]).format("YYYY-MM-DD");
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'Asia/Calcutta';
    const duration = clientData?.callDuration.split(" ")[0] || 60;
    const expertId = clientData?.expertID || currentUser?.UserId;
    const url = `https://us.uwc.world/new-uwc/uwc_expert/appointment/slots?expert_id=${expertId}&date=${formattedDate}&duration=${duration}&timezone=${encodeURIComponent(timezone)}`;


    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "76d802e426a2cb28f3760c8c8f669983f67ed775"
        }
      });
      const postResponse = await response.json();



      // Handle the new API response structure where slots are organized by date
      let slots = [];
      if (postResponse.data && postResponse.data.slots) {
        const slotsByDate = postResponse.data.slots;
        // Convert the date-keyed object to a flat array of slots
        slots = Object.values(slotsByDate).flat();
      } else if (postResponse.slots) {
        const slotsByDate = postResponse.slots;
        slots = Object.values(slotsByDate).flat();
      } else if (Array.isArray(postResponse.data)) {
        slots = postResponse.data;
      } else if (Array.isArray(postResponse)) {
        slots = postResponse;
      }

      // console.log("Processed slots:", slots);

      // Ensure slots is always an array
      setSlotsList(Array.isArray(slots) ? slots : []);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  //Slots List (Reschedule Dialog)
  useEffect(() => {
    if (clientData?.appointmentDate !== "") {
      postSlotsData();
    }
  }, [clientData]);

  const appointmentPayload = {
    expert_id: currentUser?.UserId,
    type: selectedTab.toLowerCase(),
    datetime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    page: page,
    limit: 9,
    user_search: searchQuery,
  };
  const postAppointmentsData = async () => {
    try {
      const response = await fetch(
        `https://odoo.unitedwecare.ca/new-uwc/expert/dashboard/appointments`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(appointmentPayload),
        }
      );
      const postResponse = await response.json();
      const { appointments, total_pages } = postResponse?.data;



      setAppointmentList(appointments);
      setTotalPage(total_pages);

      setLoading(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  //Appointments List
  useEffect(() => {
    postAppointmentsData();
    setPage(1);
  }, [selectedTab]);

  useEffect(() => {
    postAppointmentsData();
  }, [page]);

  // Search functionality
  useEffect(() => {
    if (loading) {
      postAppointmentsData();
    }
  }, [searchQuery, loading]);

  //console.log("APP", appointmentList)
  //Snackbar
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackbar(false);
  };

  ///Reschedule Region

  //Reschedule
  const handleReschedule = (
    clientName,
    clientImage,
    clientType,
    appointmentID,
    appointmentDate,
    appointmentTime,
    clientCallingMode,
    clientStatus,
    callDuration,
    expertID
  ) => {
    // Check if appointment can be rescheduled based on status
    // ONLY FOR AUSTRALIA
    // if (clientStatus === "Cancelled" || clientStatus === "Completed") {
    //   setSnackbarMessage(`Cannot reschedule ${clientStatus.toLowerCase()} appointment`);
    //   setOpenSnackbar(true);
    //   return;
    // }

    // Check if appointment is in the past
    const appointmentDateTime = moment(`${appointmentDate} ${appointmentTime}`, ["DD/MM/YYYY hh:mm A", "DD MMM YYYY hh:mm A"]);
    // ONLY FOR AUSTRALIA
    // if (appointmentDateTime.isBefore(moment())) {
    //   setSnackbarMessage("Cannot reschedule past appointments");
    //   setOpenSnackbar(true);
    //   return;
    // }

    // Set today's date as default for reschedule
    const todayDate = moment().format("DD/MM/YYYY");

    setClientData((prevClientData) => ({
      ...prevClientData,
      clientImage,
      clientType,
      appointmentID,
      appointmentDate: todayDate,
      appointmentTime,
      clientCallingMode,
      clientStatus,
      callDuration,
      expertID
    }));

    handleRescheduleOpen();
  };

  const handleRescheduleOpen = () => {
    setOpenRescheduleModal(true);
  };

  const testAdminEmails=[
    "contactus@asksam.com.au",
    "ccop_aus1@tmail.com",
    "aussuperadmin@yopmail.com",
    "adminmel@asksam.com.au",
    "adminava@asksam.com.au",
    "adminnikki@asksam.com.au",
    "adminlucie@asksam.com.au",
    "adminsadie@asksam.com.au",
    "aloktest2@tmail.com",
    "sumitkhanna4444@gmail.com"
  ]

  const handleRescheduleClose = () => {
    setOpenRescheduleModal(false);
    // Reset custom reschedule state
    setIsCustomReschedule(false);
    setCustomTime("");
  };

  const onToDateChange = (date) => {
    const formattedDate = dayjs(date).format("DD/MM/YYYY");
    setClientData((prevClientData) => ({
      ...prevClientData,
      appointmentDate: formattedDate,
    }));
  };

  const handleRescheduleAppointment = async (retryCount = 0) => {
    const MAX_RETRY = 3; // Maximum number of retries

    setIsRescheduled(false);

    // Format the appointment date and time for the new API
    const formattedDate = moment(clientData?.appointmentDate, ["DD/MM/YYYY", "DD MMM YYYY"]).format("YYYY-MM-DD");
    
    // Handle custom time vs predefined slot time
    let formattedTime;
    if (isCustomReschedule && customTime) {
      // For custom time, it's already in HH:mm format
      formattedTime = customTime + ":00";
    } else {
      // For predefined slots, convert from hh:mm A format
      formattedTime = moment(clientData?.appointmentTime, "hh:mm A").format("HH:mm:ss");
    }
    
    const appointmentDateTime = `${formattedDate} ${formattedTime}`;

    // Get timezone from browser or use default
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'US/Pacific';

    // Extract duration from callDuration (assuming format like "50 minutes")
    const duration = parseInt(clientData?.callDuration?.split(" ")[0]) || 50;

    let payload = {
      uwc_appointmentid: clientData?.appointmentID,
      appointment_time: appointmentDateTime,
      timezone: timezone,
      duration: duration
    };

    if(currentUser?.Emailid && testAdminEmails.includes(currentUser?.Emailid)){
      payload = {
        ...payload,
        role: 'admin'
      };
    }


    const rescheduleHeaders = {
      "Content-Type": "application/json",
      "x-api-key": "76d802e426a2cb28f3760c8c8f669983f67ed775"
    };

    try {
      const response = await fetch(
        `https://us.uwc.world/new-uwc/uwc_expert/appointment/reschedule`,
        {
          method: "POST",
          headers: rescheduleHeaders,
          body: JSON.stringify(payload),
        }
      );
      const postResponse = await response.json();

      // console.log("Reschedule response:", postResponse);

      // Check for success response (adjust based on actual API response structure)
      if (postResponse.code === 200 || postResponse.success || postResponse.status === 200 || postResponse.ResponseCode === 200) {
        // Update the appointment list with new date and time
        setAppointmentList(prevList =>
          prevList.map(appointment =>
            appointment.ID === clientData?.appointmentID
              ? {
                ...appointment,
                AppDate: clientData?.appointmentDate,
                AppTime: isCustomReschedule && customTime 
                  ? moment(customTime, "HH:mm").format("hh:mm A")
                  : clientData?.appointmentTime
              }
              : appointment
          )
        );

        setSnackbarMessage("Rescheduled successfully!");
        setOpenSnackbar(true);
        handleRescheduleClose();
        setIsRescheduled(true);
        // postAppointmentsData(); // Commented out since we're updating state directly
      } else if (postResponse?.ResponseCode == 401 && retryCount < MAX_RETRY) {
        getToken(currentUser?.Emailid).then((res) => {
          setBearerToken(res);
          setTimeout(() => handleRescheduleAppointment(retryCount + 1), 0);
        });
      } else {
        // Handle specific error cases
        let errorMessage = "Failed to reschedule appointment";

        if (postResponse?.code === 403) {
          errorMessage = postResponse?.data?.error || postResponse?.message || "Appointment cannot be rescheduled";
        } else if (postResponse?.message) {
          errorMessage = postResponse.message;
        } else if (postResponse?.data?.error) {
          errorMessage = postResponse.data.error;
        }

        console.error("Reschedule failed:", {
          code: postResponse?.code,
          message: postResponse?.message,
          data: postResponse?.data,
          payload: payload
        });

        setSnackbarMessage(errorMessage);
        setIsRescheduled(true)
        setOpenSnackbar(true)
      }
    } catch (error) {
      console.error("Error:", error);
      setSnackbarMessage("Error occurred while rescheduling");
      setIsRescheduled(true)
      setOpenSnackbar(true)
    } finally {
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    }
  };

  //Slots Section
  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const handleSlotChange = (slot) => {
    //console.log("slot", slot)
    // Convert ISO time to readable format
    const timeString = moment(slot.time).format("hh:mm A");
    setClientData((prevClientData) => ({
      ...prevClientData,
      slotID: slot.time, // Use time as ID since there's no separate id field
      appointmentTime: timeString,
    }));
  };

  ///Reschedule Region End

  ///Notes Region

  const handleNotes = (
    clientName,
    clientImage,
    clientType,
    appointmentID,
    appointmentDate,
    appointmentTime,
    clientID
  ) => {
    setClientData((prevClientData) => ({
      ...prevClientData,
      clientName,
      clientImage,
      clientType,
      appointmentID,
      appointmentDate,
      appointmentTime,
      clientID,
    }));
    handleNotesOpen();
  };

  const handleNotesOpen = () => {
    setOpenNotesModal(true);
  };

  const handleNotesClose = () => {
    setOpenNotesModal(false);
  };

  const handleNote = (e) => {
    setNote(e.target.value);
  };

  const handlePostNote = async () => {
    setIsNoteAdded(false);
    const payload = {
      jsonrpc: "2.0",
      params: {
        name: note,
        content: note,
        creator_id: currentUser?.UserId,
        assign_id: clientData?.clientID,
        is_private: "True",
      },
    };

    try {
      const response = await fetch(
        `https://odoo.unitedwecare.ca/uwc_notes/create`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(payload),
        }
      );
      const postResponse = await response.json();

      const message = await postResponse.ResponseCode;

      if (message == 200) {
        setNote("");
        setOpenNotesModal(false);
        setSnackbarMessage("Note sent successfully!");
        setOpenSnackbar(true);
        setIsNoteAdded(true);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  ///Notes Region End

  ///Prescription Region

  const handlePrescription = (
    clientName,
    clientImage,
    clientType,
    appointmentID,
    appointmentDate,
    appointmentTime
  ) => {
    setClientData((prevClientData) => ({
      ...prevClientData,
      clientName,
      clientImage,
      clientType,
      appointmentID,
      appointmentDate,
      appointmentTime,
    }));

    handlePrescriptionOpen();
  };

  const handlePrescriptionOpen = () => {
    setOpenPrescriptionModal(true);
  };

  const handlePrescriptionClose = () => {
    setOpenPrescriptionModal(false);
  };

  const handlePrescriptionName = (e) => {
    setPrescriptionName(e.target.value);
  };

  const handlePrescriptionNote = (e) => {
    setPrescriptionNote(e.target.value);
  };

  const handlePostPrescription = async (retryCount = 0) => {
    const MAX_RETRY = 3; // Maximum number of retries

    setIsPrescriptionAdded(false);

    const payload = {
      AppointmentId: +clientData?.appointmentID,
      Title: prescriptionName,
      Note: prescriptionNote,
      DocsFile: selectedFiles,
    };

    let sessionBearerToken = sessionStorage.getItem("token");

    const prescriptionHeaders = {
      "Content-Type": "application/json",
      deviceid: "123",
      devicetype: "web",
      lat: "1",
      long: "1",
      Authorization: `Bearer ${sessionBearerToken}`,
    };

    try {
      const response = await fetch(
        `https://app.uwc.world/api/appointment/saveAppointment_Documents_Files`,
        {
          method: "POST",
          headers: prescriptionHeaders,
          body: JSON.stringify(payload),
        }
      );

      const postResponse = await response.json();
      const message = await postResponse.ResponseCode;

      if (message == 200) {
        setPrescriptionName("");
        setPrescriptionNote("");
        setSelectedFiles("");
        handlePrescriptionClose();
        setSnackbarMessage("Prescription sent successfully!");
        setOpenSnackbar(true);
        setIsPrescriptionAdded(true);
      } else if (postResponse?.ResponseCode == 401 && retryCount < MAX_RETRY) {
        getToken(currentUser?.Emailid).then((res) => {
          setBearerToken(res);
          setTimeout(() => handlePostPrescription(retryCount + 1), 0);
        });
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  //Upload
  const handleFileSelect = async (event) => {
    const file = event.target.files[0];

    setIsFileLoading(true);
    if (
      file?.type === "image/png" ||
      file?.type === "image/jpg" ||
      file?.type === "image/jpeg"
    ) {
      let dirName = moment().format("MMMM_YYYY");
      //console.log("dirName", dirName);
      const storageRef = ref(storage, dirName + "/" + file.name);
      const uploadTask = uploadBytesResumable(storageRef, file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const percent = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          console.log("uploading", percent);
          // update progress
          // setPercent(percent);
        },
        (err) => enqueueSnackbar(err, { variant: "error" }),
        () => {
          // download url
          getDownloadURL(uploadTask.snapshot.ref).then((url) => {
            // console.log("file path url ", url);
            //setLoading(false);
            setSelectedFiles(url);
            setIsFileLoading(false);
          });
        }
      );
    } else {
      console.error("Incorrect  file format.");
    }

    //setSelectedFiles(files);
  };
  ///Prescription Region End

  ///Cancel Region

  const handleCancel = async (retryCount = 0) => {
    const MAX_RETRY = 3; // Maximum number of retries

    setIsCancelled(false);
    const payload = {
      uwc_appointmentid: clientData?.appointmentID,
    };

    const cancelHeaders = {
      "X-API-Key": "76d802e426a2cb28f3760c8c8f669983f67ed775",
      "Content-Type": "application/json",
    };

    try {
      const response = await fetch(
        `https://us.uwc.world/new-uwc/uwc_expert/appointment/cancel`,
        {
          method: "POST",
          headers: cancelHeaders,
          body: JSON.stringify(payload),
        }
      );
      const postResponse = await response.json();

      if (response.ok) {
        handleCancelConfirmationClose();
        setSnackbarMessage("Cancelled successfully!");
        setOpenSnackbar(true);
        setIsCancelled(true);
        setLoading(true);
        setTimeout(() => {
          postAppointmentsData();
        }, 1000);
      } else if (response.status === 401 && retryCount < MAX_RETRY) {
        getToken(currentUser?.Emailid).then((res) => {
          setBearerToken(res);
          setTimeout(() => handleCancel(retryCount + 1), 0);
        });
      } else {
        setSnackbarMessage("Failed to cancel appointment");
        setOpenSnackbar(true);
        setIsCancelled(true);
      }
    } catch (error) {
      console.error("Error:", error);
      setSnackbarMessage("Error occurred while cancelling appointment");
      setOpenSnackbar(true);
      setIsCancelled(true);
    }
  };

  const handleCancelConfirmationOpen = () => {
    setOpenCancelConfirmationModal(true);
  };

  const handleCancelConfirmationClose = () => {
    setOpenCancelConfirmationModal(false);
  };

  const handleCancelAppointment = (
    clientName,
    clientImage,
    clientType,
    appointmentID,
    appointmentDate,
    appointmentTime
  ) => {
    setClientData((prevClientData) => ({
      ...prevClientData,
      clientName,
      clientImage,
      clientType,
      appointmentID,
      appointmentDate,
      appointmentTime,
    }));

    handleCancelConfirmationOpen();
  };

  ///Cancel Region End
  const filteredSlotsData = Array.isArray(slotsList) ? slotsList.filter((item) => {
    if (!checked) {
      // Render morning slots (AM)
      return moment(item.time).format("A") === "AM";
    } else {
      // Render evening slots (PM)
      return moment(item.time).format("A") === "PM";
    }
  }) : [];

  const cancelledAppointments = appointmentList?.filter(
    (item) => item.Status == "Cancelled"
  );
  const openAppointments = appointmentList?.filter(
    (item) => item.Status !== "Cancelled"
  );

  // console.log("cancelledAppointments", cancelledAppointments);
  // console.log("appointmentList =============>", appointmentList)

  return (
    <>
      <Grid
        container
        spacing={2}
        sx={{
          backgroundColor: "#FFF",
          padding: "10px 10px 26px 10px",
          marginTop: "20px",
          marginLeft: 0,
          marginRight: 0,
          borderRadius: "10px",
          width: "100%",
        }}
      >
        {loading ? (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(370px, 1fr))",
              width: "100%",
              gap: "15px",
            }}
          >
            {Array.from(new Array(arrayLength)).map((_, index) => (
              <div
                key={index}
                style={{
                  minWidth: "100%",
                  backgroundColor: "rgb(0,0,0,0.07)",
                  padding: "10px",
                  height: "168px",
                  borderRadius: "10px",
                }}
              >
                <div className="d-flex gap-2 Card--Top my-1 p-1">
                  <Skeleton variant="circular" width={45} height={45} />

                  <div>
                    <Skeleton
                      variant="text"
                      width="8vw"
                      height={20}
                      sx={{ borderRadius: "5px" }}
                    />
                    <p>
                      <Skeleton
                        variant="text"
                        width="5vw"
                        height={20}
                        sx={{ borderRadius: "5px" }}
                      />
                    </p>
                  </div>
                </div>

                <div
                  className="Card--Timings d-flex gap-4 p-2 w-100"
                  style={{ margin: "10px 0" }}
                >
                  <Skeleton
                    variant="rounded"
                    width="45%"
                    height={20}
                    sx={{ borderRadius: "5px" }}
                  />
                  <Skeleton
                    variant="rounded"
                    width="45%"
                    height={20}
                    sx={{ borderRadius: "5px" }}
                  />
                </div>
                <div
                  className="d-flex gap-2 w-100"
                  style={{ margin: "10px 0" }}
                >
                  <Skeleton
                    variant="rounded"
                    width="45%"
                    height={34}
                    sx={{ borderRadius: "20px" }}
                  />
                  <Skeleton
                    variant="rounded"
                    width="45%"
                    height={34}
                    sx={{ borderRadius: "20px" }}
                  />
                  <Skeleton
                    variant="rounded"
                    width="10%"
                    height={40}
                    sx={{ borderRadius: "20px" }}
                  />
                </div>
              </div>
            ))}
          </div>
        ) : appointmentList?.length === 0 ? (
          <div className="NoDataAvailable">
            {CalenderSvg}
            <p>No Appointment data available</p>
          </div>
        ) : (
          <>
            <div
              style={{}}
              className="w-100 row row-cols-1 row-cols-md-2 row-cols-xl-3 "
            >
              {appointmentList?.map((item, index) => (
                <div style={{}} className="p-2 " key={item.id}>
                  <AppointmentCard
                    id={item.ID}
                    clientID={item.UserId}
                    ExpertName={item.ExpertName}
                    ExpertId={item.ExpertId}
                    img={item.ProfileImage}
                    name={item.Name}
                    clientType={item.client_type}
                    appointmentID={item.ID}
                    can_be_rescheduled={item.can_be_rescheduled}
                    can_be_cancelled={item.can_be_cancelled}
                    BookedRegisterAs={item?.BookedRegisterAs}
                    appointmentDate={item.AppDate}
                    appointmentTime={item.AppTime}
                    joinURL={item.join_url}
                    status={item.Status}
                    selectedTab={selectedTab}
                    // Pass additional data to reduce API calls in details page
                    email={item.Email}
                    phone={item.MobileNo}
                    age={item.Age}
                    gender={item.Gender}
                    country={item.Country}
                    timezone={item.TimeZone}
                    duration={item.duration}
                    callingMode={item.CallingMode}
                    onReschedule={() =>
                      handleReschedule(
                        item.Name,
                        item.ProfileImage,
                        item.client_type,
                        item.ID,
                        item.AppDate,
                        item.AppTime,
                        item.CallingMode,
                        item.Status,
                        item.duration,
                        item.ExpertId
                      )
                    }
                    onAddNote={() =>
                      handleNotes(
                        item.Name,
                        item.ProfileImage,
                        item.client_type,
                        item.ID,
                        item.AppDate,
                        item.AppTime,
                        item.UserId,
                        item.Status
                      )
                    }
                    onPrescription={() =>
                      handlePrescription(
                        item.Name,
                        item.ProfileImage,
                        item.client_type,
                        item.ID,
                        item.AppDate,
                        item.AppTime
                      )
                    }
                    onCancel={() =>
                      handleCancelAppointment(
                        item.Name,
                        item.ProfileImage,
                        item.client_type,
                        item.ID,
                        item.AppDate,
                        item.AppTime
                      )
                    }
                    appointmentCreatedBy={item?.AppointmentCeatedBy}
                    expertFeedback={item?.ExpertFeedback}
                  />
                </div>
              ))}
            </div>
            <div className="d-flex justify-content-end w-100">
              <Pagination
                count={totalPage}
                page={page}
                onChange={handleChangePage}
              />
            </div>
          </>
        )}
      </Grid>

      {/* Notes Dialog */}
      <Dialog
        className="Dialog Notes--Dialog"
        open={openNotesModal}
        onClose={handleNotesClose}
        sx={{
          maxWidth: "610px",
          width: "98%",
          minWidth: "580px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        {isNoteAdded !== null && !isNoteAdded && (
          <div
            style={{
              width: "100%",
              height: "100%",
              background: "rgb(183 216 237 / 58%)",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: "10",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </div>
        )}
        <DialogTitle>Add Notes</DialogTitle>
        <DialogContent className="Dialog--Content">
          <div className="Content--Header d-flex  align-items-center gap-2">
            <img
              src={clientData?.clientImage}
              width={45}
              style={{ borderRadius: "50%" }}
            />

            <div>
              <h6>{clientData?.clientName}</h6>
              <span>
                {clientData?.appointmentDate} | {clientData?.appointmentTime} |{" "}
                {clientData?.clientType}
              </span>
            </div>
          </div>

          <TextField
            id="outlined-multiline-static"
            label="Write Something"
            multiline
            value={note}
            rows={4}
            fullWidth
            onChange={(e) => handleNote(e)}
            sx={{ marginTop: "20px" }}
          />

          <div className="d-flex justify-content-center mt-4 mb-1">
            <Button
              variant="contained"
              className="PrimaryCTAExp"
              onClick={handlePostNote}
              disabled={note?.trim() == "" ? true : false}
            >
              Add Note
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Reschedule Dialog */}
      <Dialog
        className="Dialog Reschedule--Dialog"
        open={openRescheduleModal}
        onClose={handleRescheduleClose}
        sx={{
          maxWidth: "610px",
          width: "98%",
          minWidth: "580px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        {isRescheduled !== null && !isRescheduled && (
          <div
            style={{
              width: "100%",
              height: "100%",
              background: "rgb(183 216 237 / 58%)",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: "10",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </div>
        )}
        <DialogTitle>Reschedule Appointment </DialogTitle>
        <DialogContent className="Dialog--Content">
          <div className="Content--Header d-flex align-items-center gap-2">
            <img
              alt=""
              src={clientData?.clientImage}
              width={45}
              style={{ borderRadius: "50%" }}
            />

            <div>
              <h6>{clientData?.clientName}</h6>
              <span>
                {clientData?.appointmentDate} | {clientData?.appointmentTime} |{" "}
                {clientData?.clientType}
              </span>
            </div>
          </div>

          <div>
            <h4>Reschedule to</h4>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="To date"
                format="DD/MM/YYYY"
                value={dayjs(clientData?.appointmentDate, "DD/MM/YYYY")}
                onChange={onToDateChange}
                sx={{
                  width: "100%",
                  marginBottom: "8px",
                  backgroundColor: "#FFF",
                }}
              />
            </LocalizationProvider>
          </div>

          <div>
            {/* Toggle between predefined slots and custom time */}
            <div className="d-flex gap-1 SlotTiming mb-3">
              <p className={`${!isCustomReschedule ? "SelectedSlot" : ""}`}>
                Predefined Slots
              </p>
              <Switch
                checked={isCustomReschedule}
                onChange={(e) => {
                  setIsCustomReschedule(e.target.checked);
                  if (e.target.checked) {
                    // Reset slot selection when switching to custom
                    setClientData(prev => ({ ...prev, slotID: 0 }));
                  } else {
                    // Reset custom time when switching to predefined slots
                    setCustomTime("");
                  }
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
              <p className={`${isCustomReschedule ? "SelectedSlot" : ""}`}>
                Custom Time
              </p>
            </div>

            {isCustomReschedule ? (
              // Custom time input
              <div className="mb-3">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    label="Preferred Time"
                    value={customTime ? dayjs(customTime, "HH:mm") : dayjs().hour(0).minute(0)}
                    onChange={(newValue) => {
                      if (newValue) {
                        const time24Format = newValue.format("HH:mm");
                        const time12Format = newValue.format("hh:mm A");
                        setCustomTime(time24Format);
                        // Update clientData with custom time
                        setClientData(prev => ({
                          ...prev,
                          slotID: time24Format,
                          appointmentTime: time12Format
                        }));
                      } else {
                        setCustomTime("");
                        setClientData(prev => ({
                          ...prev,
                          slotID: "",
                          appointmentTime: ""
                        }));
                      }
                    }}
                    sx={{ width: "100%" }}
                    ampm={true}
                  />
                </LocalizationProvider>
                <p style={{ 
                  fontSize: "12px", 
                  color: "#666", 
                  marginTop: "8px",
                  fontStyle: "italic"
                }}>
                  Note: Custom time requests will be reviewed and confirmed by the expert
                </p>
              </div>
            ) : (
              // Predefined slots grid
              <Grid
                container
                gap={2}
                sx={{ width: "100%", margin: "0" }}
                className="Timings"
              >
                {/* .sort((a,b) => a.slot_id - b.slot_id) */}
                {slotsList?.length > 0 ? (
                  slotsList?.map((item) => {
                    // Convert ISO time to readable format
                    const timeString = moment(item.time).format("hh:mm A");
                    const isAM = moment(item.time).format("A") === "AM";

                    return (
                      <Grid
                        item
                        xs={2}
                        key={item.time}
                        className={`AvailableSlot ${item.time === clientData?.slotID ? "SelectedSlot" : ""
                          }`}
                        onClick={() => handleSlotChange(item)}
                      >
                        <p>{timeString}</p>
                      </Grid>
                    );
                  })
                ) : (
                  <p className="mx-auto" style={{ fontWeight: "500" }}>
                    No slots available for selected dates
                  </p>
                )}
              </Grid>
            )}
          </div>

          <Button
            className="PrimaryCTAExp"
            variant="contained"
            disableElevation
            sx={{ margin: "62px auto 20px auto" }}
            onClick={handleRescheduleAppointment}
            disabled={
              isCustomReschedule 
                ? !customTime 
                : clientData.slotID === 0
            }
          >
            {isCustomReschedule ? "Request Custom Reschedule" : "Confirm and Reschedule"}
          </Button>
        </DialogContent>
      </Dialog>

      {/* Precriptions Dialog */}
      <Dialog
        className="Dialog Prescription--Dialog"
        open={openPrescriptionModal}
        onClose={handlePrescriptionClose}
        sx={{
          maxWidth: "610px",
          width: "98%",
          minWidth: "580px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        {isPrescriptionAdded !== null && !isPrescriptionAdded && (
          <div
            style={{
              width: "100%",
              height: "100%",
              background: "rgb(183 216 237 / 58%)",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: "10",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </div>
        )}
        <DialogTitle>Add Prescription</DialogTitle>
        <DialogContent className="Dialog--Content">
          <div className="Content--Header d-flex align-items-center gap-2">
            <img
              src={clientData?.clientImage}
              width={45}
              style={{ borderRadius: "50%" }}
            />

            <div>
              <h6>{clientData?.clientName}</h6>
              <span>
                {clientData?.appointmentDate} | {clientData?.appointmentTime} |{" "}
                {clientData?.clientType}
              </span>
            </div>
          </div>

          <TextField
            id="outlined-multiline-static"
            label="Prescription Name"
            value={prescriptionName}
            onChange={handlePrescriptionName}
            fullWidth
            sx={{ marginTop: "20px" }}
          />
          <TextField
            id="outlined-multiline-static"
            label="Prescription notes"
            value={prescriptionNote}
            onChange={handlePrescriptionNote}
            multiline
            rows={4}
            fullWidth
            sx={{ marginTop: "10px", marginBottom: "10px" }}
          />
          <div
            className="upload-button"
            style={{ marginTop: "0", height: "100%" }}
          >
            <label
              htmlFor="file-upload"
              className="upload-button-label"
              style={{ height: "100%", fontSize: "16px" }}
            >
              <FileUploadOutlinedIcon className="upload-button-icon" />
              Upload
            </label>
            {isFileLoading !== null && isFileLoading ? (
              <div className="d-flex align-items-center mx-auto">
                <CircularProgress
                  sx={{ width: "20px !important", height: "20px !important" }}
                />
              </div>
            ) : (
              <>
                <input
                  id="file-upload"
                  type="file"
                  multiple
                  onChange={handleFileSelect}
                  className="upload-button-input"
                />
                {selectedFiles && (
                  <div className="selected-files">
                    <div className="file-name">{selectedFiles}</div>
                  </div>
                )}
              </>
            )}
          </div>

          <Button
            className="PrimaryCTAExp"
            variant="contained"
            disableElevation
            sx={{ margin: "30px auto 20px auto" }}
            onClick={handlePostPrescription}
            disabled={
              prescriptionName == "" || selectedFiles === "" ? true : false
            }
          >
            Add Prescription
          </Button>
        </DialogContent>
      </Dialog>

      {/* Cancel Dialog */}
      <Dialog
        className="Dialog Cancel--Dialog"
        open={openCancelConfirmationModal}
        onClose={handleCancelConfirmationClose}
        sx={{
          maxWidth: "610px",
          width: "98%",
          minWidth: "580px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        {isCancelled !== null && !isCancelled && (
          <div
            style={{
              width: "100%",
              height: "100%",
              background: "rgb(183 216 237 / 58%)",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: "10",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </div>
        )}
        <DialogContent className="Dialog--Content">
          <WarningRoundedIcon />
          <h6>
            Are you Sure you want to cancel this Appointment? This action cannot
            be undone
          </h6>
          <div className="Content--Header d-flex align-items-center gap-2">
            <img
              src={clientData?.clientImage}
              width={45}
              style={{ borderRadius: "50%" }}
            />

            <div>
              <h6>{clientData?.clientName}</h6>
              <span>
                {clientData?.appointmentDate} | {clientData?.appointmentTime} |{" "}
                {clientData?.clientType}
              </span>
            </div>
          </div>

          <div className="CTA--Container d-flex align-items-center gap-3 mt-3">
            <Button
              sx={{
                backgroundColor: "#F5F5F5",
                color: "#000",
                height: "50px",
                padding: "14px 24px",
                borderRadius: "10px",
                textTransform: "capitalize",
                "&:hover": {
                  backgroundColor: "#F5F5F5",
                  color: "#000",
                },
              }}
              className=""
              variant="contained"
              disableElevation
              onClick={handleCancelConfirmationClose}
            >
              No, Take me back
            </Button>

            <Button
              className="PrimaryCTAExp"
              variant="contained"
              disableElevation
              onClick={handleCancel}
            >
              Yes, Cancel it
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AppointmentDefaultView;
